import { useContext, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import PopUp from 'src/components/AppealForm/Qualifications/PopUp';
import RadioButton from 'src/components/AppealForm/Qualifications/RadioButton';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import FormContext from 'src/contexts/appeal-context';

const QUALIFICATION_COUNT = 6;

export default function Qualifications() {
  const [checked, setChecked] = useState({});
  const [open, setOpen] = useState(false);
  const { setDisableNext } = useContext(FormContext);
  const form = useFormikContext();

  const allYesSelected = () => {
    const values = Object.values(form.values);
    return !(values.every((val) => val === 'yes') && values.length === QUALIFICATION_COUNT);
  };

  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSelect = (name, selection) => {
    setChecked((prev) => {
      return { ...prev, [name]: selection };
    });
  };

  useEffect(() => {
    setDisableNext(allYesSelected());
  }, [checked]);

  return (
    <>
      <PopUp isOpen={open} handleClose={handleClose} />
      <Section title="Qualifications for Reduction of Non-Filing Penalty">
        <Subheader>
          To complete the appeal form, each of the conditions below must be met and answered with a
          &quot;Yes&quot;
        </Subheader>
        <RadioButton handleSelect={handleSelect} name="causedByCountyError" openPopUp={handleOpen}>
          The assessment of the penalty was <b>NOT</b> caused by a County error
        </RadioButton>
        <RadioButton handleSelect={handleSelect} name="paidInFull" openPopUp={handleOpen}>
          <b>ALL</b> taxes for the current year and for all prior years have been paid in full
        </RadioButton>
        <RadioButton handleSelect={handleSelect} name="doesNotExceedPenalty" openPopUp={handleOpen}>
          The tax amount for the subject year does not exceed two thousand five hundred dollars
          ($2,500.00)
        </RadioButton>
        <RadioButton
          handleSelect={handleSelect}
          name="assignedBecauseOfFailure"
          openPopUp={handleOpen}
        >
          The penalty has been assessed because of a failure to file the signed statement required
          by{' '}
          <Link
            className="font-medium text-blue-600 hover:underline dark:text-blue-500"
            to={`/power-of-assessors`}
            rel="noreferrer"
            target="_blank"
          >
            Utah Code &sect; 59-2-306
          </Link>{' '}
          or because of a failure to file the signed statement with respect to name and place of
          residence
        </RadioButton>
        <RadioButton handleSelect={handleSelect} name="noPenaltyUnderUCA" openPopUp={handleOpen}>
          The current owner has not been assessed a penalty under{' '}
          <Link
            className="font-medium text-blue-600 hover:underline dark:text-blue-500"
            to={`/refusal-to-sign`}
            rel="noreferrer"
            target="_blank"
          >
            Utah Code &sect; 59-2-307(1)
          </Link>
          , related to any of the prior three (3) tax years
        </RadioButton>
        <RadioButton
          handleSelect={handleSelect}
          name="filedDelinquentStatement"
          openPopUp={handleOpen}
        >
          The owner has filed the delinquent signed statement prior to or at the time of filing the
          request for reduction or waiver of the penalty
          <span className="mt-2 block italic">
            **Please note a late filing will NOT change an assessment amount for the current tax
            year.**
          </span>
        </RadioButton>
        <h5 className="text-center">
          <p>IF YOU QUALIFY YOU WILL RECEIVE A ONE TIME REDUCTION OF THE PENALTY.</p>
          <p>YOU MUST FILE YOUR AFFIDAVIT TIMELY EACH YEAR.</p>
        </h5>
      </Section>
    </>
  );
}
